import { useQuery } from '@tanstack/react-query';
import { matchPath, useLocation } from 'react-router-dom';
import { featureFlags } from '../api';
import { FLAGS } from '../providers/feature-flags-provider/constants';

const FLAG_NAMES = Object.values(FLAGS);
const FEATURE_FLAG_STALE_TIME_MS = 5 * 60 * 1000;

const getEntityRefFromPath = pathname => {
  if (matchPath({ path: '/summary/:data/*' }, pathname)) {
    return null;
  }

  return matchPath({ path: '/:entityRef/*' }, pathname)?.params?.entityRef ?? null;
};

export const useListFeatureFlags = ({ enabled = true } = {}) => {
  const { pathname } = useLocation();
  const entityRef = getEntityRefFromPath(pathname);

  return useQuery({
    queryKey: ['list-feature-flags', entityRef, FLAG_NAMES],
    queryFn: async () => {
      const results = await Promise.all(
        FLAG_NAMES?.map?.(name => featureFlags?.listFeatureFlags?.({ entityRef, flagName: name })) ?? []
      );
      return Object.assign({}, ...(results ?? []));
    },
    enabled: Boolean(entityRef && enabled),
    staleTime: FEATURE_FLAG_STALE_TIME_MS,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};
